import { BaseResponse } from "src/models/BaseModel";
import { CreateTagBody, Tag } from "src/models/TagModel";
import { PrivateApi } from "./BaseApi";

export const tagsApi = PrivateApi.injectEndpoints({
  endpoints: (builder) => ({
    getTags: builder.query<BaseResponse<Tag[]>, void>({
      query: () => ({
        url: "Dashboard/GetTags",
        method: "GET",
      }),
      providesTags: ["Tags"],
    }),
    createTag: builder.mutation<BaseResponse<Tag[]>, CreateTagBody>({
      query: (body) => ({
        url: "Dashboard/CreateTag",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Tags"],
    }),
    updateTag: builder.mutation<BaseResponse<Tag[]>, CreateTagBody>({
      query: (body) => ({
        url: "Dashboard/UpdateTag",
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tags"],
    }),
    deleteTag: builder.mutation<BaseResponse<Tag[]>, { data: { id: number } }>({
      query: (body) => ({
        url: "Dashboard/DeleteTag",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Tags"],
    }),
  }),
});

export const {
  useGetTagsQuery,
  useDeleteTagMutation,
  useUpdateTagMutation,
  useCreateTagMutation,
} = tagsApi;
